import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/GLAccountReqs/GLAccountReqs'

function* getGLAccounts(action) {
    try {
        const result = yield call(req.getGLAccountsReq, action);
        if (result.success) {
            yield put({ type: types.GET_GL_ACCOUNTS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_GL_ACCOUNTS_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_GL_ACCOUNTS_FAILURE, message: e?.message });
    }
}

export default function* GLAccountSaga() {
    yield takeLatest(types.GET_GL_ACCOUNTS, getGLAccounts);
}
